import React, { createContext, useEffect, useState, useMemo } from 'react';
import { startEventsSync } from './mainpage/account_sync/events_sync';

const EventsContext = createContext();

function shallowEqualEvents(a, b) {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
        const x = a[i], y = b[i];
        if (!x || !y || x.type !== y.type || x.text !== y.text) return false;
    }
    return true;
}

export const EventsProvider = ({ wallet, jwt, children }) => {
    const [events, setEvents] = useState([]);
    const [lastSync, setLastSync] = useState(0);

    useEffect(() => {
        if (!wallet || !jwt) return;

        const stop = startEventsSync({
            wallet_address: wallet,
            jwt,
            onUpdate: (items) => {
                setEvents(prev => {
                    if (shallowEqualEvents(prev, items)) return prev;
                    return items;
                });
                setLastSync(Date.now());
            },
            onError: (err) => {
                console.warn('[EventsContext] Events sync failed:', err?.message || err);
            },
            intervalMs: 60_000,
        });

        return stop;
    }, [wallet, jwt]);

    const value = useMemo(() => ({ events, lastSync }), [events, lastSync]);

    return (
        <EventsContext.Provider value={value}>
            {children}
        </EventsContext.Provider>
    );
};

export default EventsContext;
